import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "src/service/http.service";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { DatePipe, Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-upload-result",
  templateUrl: "./upload-result.component.html",
  styleUrls: ["./upload-result.component.css"],
})
export class UploadResultComponent implements OnInit {
  //yearList = ["2020-21", "2021-22", "2022-23", "2023-24"];
  yearList = ["2020-21", "2021-22", "2022-23", "2023-24", "2024-25"];

  form: FormGroup;
  orders = [
    {
      name: "Automatic",
      id: 1,
    },
    {
      name: "Manual",
      id: 2,
    },
  ];
  title = "XLSRead";
  file: File;
  arrayBuffer: any;
  filelist: any = [];
  selectedOption: any;
  isSubmitted = false;
  model: any = {};
  isLoading!: boolean;
  ngForm: any;
  fieldTextType!: boolean;

  formRegister: FormGroup;
  activeColor: string = 'green';
  baseColor: string = '#ccc';
  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: string | undefined;
  filename: any;
  isSubmittedOrg: boolean = false;

  arraylist: any = [];
  formContainerUpload: FormGroup;
  radioForm: FormGroup;

  divisionsList: any;
  selectedDivision: string;
  challanList: any;
  totalLength: any;
  formatStatus: Boolean = false;
  factory_container_no: any;
  selectedDivisionValue: any;
  challanName: any;
  sampleDetails: any;
  samplesData: any;
  id: string;
  challanDetailsObj: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,
    private httpService: HttpService,
    private _Activatedroute: ActivatedRoute,
  ) {
    this.formContainerUpload = this.formBuilder.group({
      tray: ["", [Validators.required]],
      noOfSamples: ["", [Validators.required]],
      sampleNumber: [""],
      morphine: [""],
      consistency: [""],
      morphineDob: [""],
    });
    this.radioForm = this.formBuilder.group({
      batchProcess: [""],
    });
    this.radioForm.patchValue({ batchProcess: "Automatic" });
  }
  dynamicArray: Array<any> = [];
  newDynamic: any = {};

  ngOnInit(): void {
    this.newDynamic = {
      bagNumber: "",
      class: "",
      netWeight: "",
      grossWeight: "",
    };
    this.dynamicArray.push(this.newDynamic);
   
    this._Activatedroute.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.getSampleDetails();
    });
  }
  //method to get sample details
  getSampleDetails() {
    const userId = localStorage.getItem("uuid");

    const trayObject = [
      {
        _methodId: "47",
        _trayId: this.id,
        _userId: userId,
      },
    ];
     this.spinner.show();
    this.httpService.editTray(trayObject).subscribe(
      (result) => {
      this.spinner.hide();

      // const samplesReceivedData = JSON.parse(
      //   localStorage.getItem("samplesReceivedData")
      // );
      

      // this.formContainerUpload.controls["tray"].setValue(
      //   samplesReceivedData.trayId
      // );
      // this.formContainerUpload.controls["noOfSamples"].setValue(
      //   samplesReceivedData.noOfSampling
      // );
      // const samplesData = data.responseData[2].filter(
      //   (res) => res.trayId === samplesReceivedData.trayId
      // );
      // this.samplesData = samplesData;
      // this.formContainerUpload.controls["sampleNumber"].setValue(
      //   samplesData[0].sysSampleId
      // );
      // this.formContainerUpload.controls["morphine"].setValue(
      //   samplesData[0].Morphine
      // );
      // this.formContainerUpload.controls["consistency"].setValue(
      //   samplesData[0].Consistency
      // );
      // this.formContainerUpload.controls["morphineDob"].setValue(
      //   samplesData[0].Morphine_ODB
      // );


      this.challanDetailsObj = result.responseData[1];

      this.challanDetailsObj.sort((a, b) =>
        a.trayId > b.trayId ? 1 : -1
      );

      this.formContainerUpload.controls["tray"].setValue(
        this.challanDetailsObj[0].trayId
      );
      // this.formContainerUpload.controls["dateOfTesting"].setValue(
      //   this.challanDetailsObj[0].dateOfReceipt
      // );
      this.formContainerUpload.controls["noOfSamples"].setValue(
        this.challanDetailsObj[0].no_of_samples
      );
    });
  }

  //method to delete file
  deleteFile() {
    this.file = null;
    this.filelist = [];
    this.arraylist.length = 0;
    this.showFileUploadError = false;
  }

  handleDragEnter() {
    this.dragging = true;
  }

  handleDragLeave() {
    this.dragging = false;
  }

  handleDrop(e: any) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleImageLoad() {
    this.imageLoaded = true;
  }

  showFileUploadError: any = false;

  //change method file input
  handleInputChange(e: any) {
    try {
      this.formatStatus = false;
      var userid = localStorage.getItem("uuid");
      var orgid = localStorage.getItem("orgid");
      this.file = e.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        this.arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.filelist = [];
        const cupAll = [];
      };
    } catch (err) {
      alert(err);
    }
  }

  _handleReaderLoaded(e: any) {
    var reader = e.target;
    this.imageSrc = (reader.result as string).split(",").pop();
    this.loaded = true;
  }

  //method to download the file
  downloadFile() {
    let link = document.createElement("a");
    link.download = "Update-Samples";
    link.href = "assets/uploadResultTemplate.xlsx";
    link.click();
  }

  //submit file method
  onSubmit() {
    this.isSubmitted = true;
    if (this.formContainerUpload.valid) {
      const uploadData = [];
      const userId = localStorage.getItem("uuid");
     console.log(this.arraylist)
      this.arraylist.forEach((element) => {
        uploadData.push({
          // Morphine: element.MORPHINE,
          // Consistency: element.CONSISTENCY,
          // trayId: this.formContainerUpload.value.tray,
          // tray_seq: element.TRAY_SEQ_ID,

          // _userId: userId,

          "Morphine":  element.MORPHINE,
          "Consistency": element.CONSISTENCY,
          "trayId": this.formContainerUpload.value.tray,
          "_sampleId": element.SampleID,
          _userId: userId,
        });
      });

      this.httpService
        .bulkupdateResultUploaded(uploadData)
        .subscribe((result) => {
          const count = result["responseData"][1].filter(
            (samples) => samples.status === "In-Valid"
          );
          const count1 = result["responseData"][1].filter(
            (samples) => samples.status === "Valid"
          );
          console.log(count)
          if (count && count.length > 0) {
            Swal.fire({
              title: "Wrong File Format",
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Yes",
              customClass: {
                container: "my-swal-two",
                confirmButton: "your-confirm-button-class-one",
              },
            }).then((result2) => {
              this.deleteFile();
            });
          } else {
            const userId = localStorage.getItem("uuid");

            const data = [{ 
            //   batchId: count1[0]["batchId"],
            //  _userId: userId

            "_methodId": "55",
        "_batchId": count1[0]["batchId"],
         "_validate": "UPDATED",
        "_userId": userId
             }]
            this.httpService
              .bulkupload_update(data)
              .subscribe((uplodResult) => {
                Swal.fire({
                  title: "Uploaded Successfully",
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonText: "Yes",
                  customClass: {
                    container: "my-swal-two",
                    confirmButton: "your-confirm-button-class-one",
                    cancelButton: "your-cancel-button-class-one",
                  },
                }).then((result2) => {
                  this.location.back();
                });
              });
          }
        });
    }
  }
}
